import { create } from 'zustand';
import { organizationService } from '@/services/superAdmin/organizationService';

export const useOrganizationStore = create((set, get) => ({
  organizations: [],
  selectedOrganization: null,
  loading: false,
  error: null,

  fetchOrganizations: async () => {
    set({ loading: true, error: null });
    try {
      const res = await organizationService.getOrganizations();
      set({ organizations: res.data.items || [], loading: false });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  fetchOrganizationById: async (id) => {
    set({ loading: true, error: null });
    try {
      const res = await organizationService.getOrganizationById(id);
      set({ selectedOrganization: res.data, loading: false });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  createOrganization: async (data) => {
    set({ loading: true, error: null });
    try {
      await organizationService.createOrganization(data);
      // Refresh list
      await get().fetchOrganizations();
      return true;
    } catch (err) {
      set({ error: err.message, loading: false });
      throw err;
    }
  },

  updateOrganization: async (id, data) => {
    set({ loading: true, error: null });
    try {
      await organizationService.updateOrganization(id, data);
      await get().fetchOrganizations();
      return true;
    } catch (err) {
      set({ error: err.message, loading: false });
      throw err;
    }
  },
}));
